const EmployeeProfile = (props) => {
    const {avatar, record, size = "sm"} = props;
    return (
        <div className="flex items-center gap-3">
            <img 
                src={avatar} 
                alt="Profile"
                className={`avatar rounded-full border-2 border-gray-300 ${size}`}
            />
            <div>
                <div>{record?.employee_name}</div>
                <div>{record?.emp_code}</div>
            </div>
        </div>
    );
}

export default EmployeeProfile;
